import { render } from "./partner-details.vue?vue&type=template&id=6776f09e"
import script from "./partner-details.vue?vue&type=script&lang=js"
export * from "./partner-details.vue?vue&type=script&lang=js"

import "./partner-details.vue?vue&type=style&index=0&id=6776f09e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__